import { render, staticRenderFns } from "./ProcessExaminationPaper.vue?vue&type=template&id=f0771860&scoped=true"
import script from "./ProcessExaminationPaper.vue?vue&type=script&lang=js"
export * from "./ProcessExaminationPaper.vue?vue&type=script&lang=js"
import style0 from "./ProcessExaminationPaper.vue?vue&type=style&index=0&id=f0771860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0771860",
  null
  
)

export default component.exports